'use strict'

import http from './http-common'
import authHeader from './auth-header'

const getAll = (companyId) => {
  return http.axiosClient.get(`/invoiceTransactions?companyId=${companyId}`, {
    headers: authHeader()
  })
}

const get = (id) => {
  return http.axiosClient.get(`/invoiceTransactions/${id}`, {
    headers: authHeader()
  })
}

const create = (data) => {
  return http.axiosClient.post('/invoiceTransactions', data, {
    headers: authHeader()
  })
}

const update = (id, data) => {
  return http.axiosClient.put(`/invoiceTransactions/${id}`, data, {
    headers: authHeader()
  })
}

const remove = (id) => {
  return http.axiosClient.delete(`/invoiceTransactions/${id}`, {
    headers: authHeader()
  })
}

const findByCustomer = (customerId) => {
  return http.axiosClient.get(`/invoiceTransactions?customerId=${customerId}`, { headers: authHeader() })
}

const findByInvoice = (invoiceId) => {
  return http.axiosClient.get(`/invoiceTransactions?invoiceId=${invoiceId}`, { headers: authHeader() })
}

const downloadExcel = (companyId) => {
  return http.axiosClient.get(`/invoiceTransactions/download/excel?companyId=${companyId}`, { headers: authHeader() })
}

export default {
  getAll,
  get,
  create,
  update,
  remove,
  findByCustomer,
  findByInvoice,
  downloadExcel
}
